/** Do not change directly this file, instead create a environment.ts from environment.ts.dist */

//import { environment as overrides } from './environment.ts'
import { environment as overrides } from "./environment.ts";
import environmentServerSide from "./environmentServerSide.ts";

export const isDevelopment =
  window.location.origin.includes("uat") ||
  window.location.origin.includes("dev") ||
  window.location.origin.includes("local");
export const isLocal = window.location.origin.includes("local.olkypay.local");
export const isUAT = window.location.origin.includes("uat");
type ConfigType = {
  APP_VERSION: string;
  OLKY_MAIN_LINK: string;
  OLKY_SUPPORT_LINK: string;
  OLKY_PRIVACY_POLICY_LINK: string;
  OLKY_HELP_LINK: string;
  OLKY_ABOUT_LINK: string;
  OLKY_LEGAL_LINK: string;
  OLKY_CGU_CARD_BUSINESS_FR: string;
  OLKY_CGU_CARD_BUSINESS_EN: string;
  OLKYPASS_CGU_FR: string;
  OLKYPASS_CGU_EN: string;
  APP_ROOT_API: string;
  API_CHAT_ALGOREG: string;
  OLKY_SUPPORT_URL: string;
  API_VID_ALGOREG: string;
  RECAPTCHA_PUBLIC_KEY: string;
  OLKYPASS_MODE: boolean; //Probably deprecated now
  SITE_NETCHAIN_ID: string;
  POLYGON_NODE: string[];
  BLOCK_EXPLORER: string;
  CHAIN_NAME: string;
  TOKEN_ADDRESS: string;
  TOKEN_SYMBOL: string;
  TOKEN_DECIMALS: number;
  TOKEN_IMAGE: string;
  KYCOIN_BUY_EXTERNAL_PAGE: string;
  URL_GOV_FR: string;
  OLKY_BANKING_URL: string;
  OLKY_PASS_URL: string;
  SOURCE_MAP: boolean;
  DISABLE_CARD_PAYMENT: boolean;
  PAYLINE_CSS_LINK: string;
  PAYLINE_JS_LINK: string;
  DISABLE_DESKOIN_CRYPTO: boolean;
  PRIVY_APP_ID: string;
  USE_PRIVY: boolean;
  PRIVY_CLIENT_ID: string;
  SENTRY_URL: string;
  ACTIVATE_OLKYPASS_PRO?: boolean;
};
const config = {
  APP_VERSION: "1.1.3",
  OLKY_MAIN_LINK: "https://www.olky.eu/",
  OLKY_SUPPORT_LINK: "/universe/support/",
  OLKY_PRIVACY_POLICY_LINK: "/cgu/privacy_policy",
  OLKY_HELP_LINK: "/universe/faq",
  OLKY_ABOUT_LINK: "/universe/about",
  OLKY_LEGAL_LINK: "/cgu/legal",
  OLKY_CGU_CARD_BUSINESS_FR: "/files/pay/cgu-olkypay-carte-business-fr.pdf?1.0.1",
  OLKY_CGU_CARD_BUSINESS_EN: "/files/pay/cgu-olkypay-carte-business-en.pdf?1.0.1",
  OLKYPASS_CGU_FR: "https://www.olky.eu/files/pass/cgu-olkypass-fr.pdf",
  OLKYPASS_CGU_EN: "https://www.olky.eu/files/pass/cgu-olkypass-en.pdf",
  APP_ROOT_API: "https://api.uat.olkypay.com",
  API_VID_ALGOREG: "https://vid.olky-dev.algoreg.com",
  RECAPTCHA_PUBLIC_KEY: "6LeXEJ0lAAAAACBgL1wKFXUEUg6SbVAFpIIFVkWq",
  URL_GOV_FR: "https://geo.api.gouv.fr/",
  API_CHAT_ALGOREG: "https://chat.olky-dev.algoreg.com/",
  OLKY_SUPPORT_URL: "https://support.olkypay.com/",
  OLKYPASS_MODE: false, //Probably deprecated now,
  ...(isDevelopment
    ? {
        SITE_NETCHAIN_ID: "0x14a34",
        POLYGON_NODE: ["https://base-sepolia.drpc.org"],
        BLOCK_EXPLORER: "https://sepolia.basescan.org/",
        CHAIN_NAME: "Base Testnet",
        TOKEN_ADDRESS: "0xF4cCd9518e4D44864a8B337122181e41b4BB8C3b",
        TOKEN_SYMBOL: "KYPAY",
        TOKEN_DECIMALS: 18,
        TOKEN_IMAGE: "https://www.olky.eu/images/kypay/kyPay-logo-light.svg"
      }
    : {
        SITE_NETCHAIN_ID: "0x89",
        POLYGON_NODE: [
          "https://polygon-rpc.com/",
          "https://polygon-bor-rpc.publicnode.com",
          "https://polygon.drpc.org",
          "https://polygon-mainnet.public.blastapi.io",
          "https://rpc.ankr.com/polygon"
        ],
        BLOCK_EXPLORER: "https://polygonscan.com/",
        CHAIN_NAME: "Polygon Mainnet",
        TOKEN_ADDRESS: "0xE833fEBb65da5358E898C10b398A21a4546f3825",
        TOKEN_SYMBOL: "KYPAY",
        TOKEN_DECIMALS: 18,
        TOKEN_IMAGE: "https://www.olky.eu/images/kypay/kyPay-logo-light.svg"
      }),
  OLKY_PASS_URL: isDevelopment
    ? isUAT
      ? "https://pass.uat.olkypay.com/"
      : "https://newpass.dev.olkypay.local/"
    : "https://app.olky.eu/",
  DISABLE_CARD_PAYMENT: false,
  PAYLINE_CSS_LINK: isDevelopment
    ? "https://homologation-payment.cdn.payline.com/cdn/styles/widget-min.css"
    : "https://payment.cdn.payline.com/cdn/styles/widget-min.css",
  PAYLINE_JS_LINK: isDevelopment
    ? "https://homologation-payment.cdn.payline.com/cdn/scripts/widget-min.js"
    : "https://payment.cdn.payline.com/cdn/scripts/widget-min.js",

  DISABLE_DESKOIN_CRYPTO: false,
  SENTRY_URL: isDevelopment
    ? "https://5139cef7599c037faf5ad949a150a740@ORT-ADM-Sentry-01.olkypay.local/2"
    : "",
  ACTIVATE_OLKYPASS_PRO: true,

  // @TODO Use Infura instead for more stability
  ...((overrides as Partial<ConfigType>) ?? {}),
  ...(environmentServerSide as Partial<ConfigType>)
} as ConfigType;
export default config;
